/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

// Absolute import
import React from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col, Input } from 'reactstrap';
import bootstrap from 'bootstrap/dist/css/bootstrap.css';
// Relative import
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';
import s from '../../../assets/styles/style.sass';
import s2 from '.././Order.sass';

import imgPhone from '../../../assets/img/icon_phone.png';
import imgPhone2 from '../../../assets/img/icon_phone@2x.png';
import imgName from '../../../assets/img/icon_avatar.png';
import imgName2 from '../../../assets/img/icon_avatar@2x.png';

import {
  updateOrderDetailInfoAction,
  setIsValidOrder,
  setIsClickConfirmOrder,
} from '../../../actions/order';
import { getAuth } from '../../../service/auth';

class Order14ContactInfoWithTW extends React.Component {
  static propTypes = {
    isClickConfirmOrder: PropTypes.bool.isRequired,
    updateOrderDetailInfoAction: PropTypes.func.isRequired,
    setIsValidOrder: PropTypes.func.isRequired,
    modelDataText: PropTypes.shape().isRequired,
    setting: PropTypes.shape().isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      name: getAuth().username,
      phone: getAuth().phone,
      phoneExt: '',
      receiverPhone: '',
      receiverName: '',
      isValidName: true,
      isValidPhone: true,
      isValidReceiverName: true,
      isValidReceiverPhone: true,
      scrollToComponent: null,
    };
    this.setScrollToComponent = this.setScrollToComponent.bind(this);
    this.scrollToAndReturnIsValid = this.scrollToAndReturnIsValid.bind(this);
  }

  componentDidMount() {
    this.setScrollToComponent();
    this.onChangeName(getAuth().username);
    this.onChangePhone(getAuth().phone);
    this.props.updateOrderDetailInfoAction(
      'phone_number',
      null,
      getAuth().phone,
    );
    this.props.updateOrderDetailInfoAction(
      'nickname',
      null,
      getAuth().username,
    );
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.isClickConfirmOrder !== this.props.isClickConfirmOrder) {
      this.props.updateOrderDetailInfoAction('nickname', null, this.state.name);
      this.props.updateOrderDetailInfoAction(
        'phone_number',
        null,
        this.state.phone,
      );
      this.props.updateOrderDetailInfoAction(
        'order_request_extra_attributes',
        'email_address',
        this.state.email,
      );
      this.props.updateOrderDetailInfoAction(
        'phone_number_ext',
        null,
        this.state.phoneExt,
      );
      this.props.updateOrderDetailInfoAction(
        'order_request_extra_attributes',
        'receiver_name',
        this.state.receiverName,
      );
      this.props.updateOrderDetailInfoAction(
        'order_request_extra_attributes',
        'receiver_phone_number',
        this.state.receiverPhone,
      );
      if (this.state.name === '') {
        this.setState({ isValidName: false });
        this.scrollToAndReturnIsValid();
      } else {
        this.setState({ isValidName: true });
      }
      const phonePatt = new RegExp(this.props.setting.PHONE_REGEX);
      if (!phonePatt.test(this.state.phone)) {
        this.setState({ isValidPhone: false });
        this.scrollToAndReturnIsValid();
      } else {
        this.setState({ isValidPhone: true });
      }
      if (this.state.receiverName !== '' || this.state.receiverPhone !== '') {
        if (this.state.receiverName === '') {
          this.setState({ isValidReceiverName: false });
          this.scrollToAndReturnIsValid();
        } else {
          this.setState({ isValidReceiverName: true });
        }
        if (this.state.receiverPhone === '') {
          this.setState({ isValidReceiverPhone: false });
          this.scrollToAndReturnIsValid();
        } else {
          this.setState({ isValidReceiverPhone: true });
        }
      }
    }
  }

  onChangeName(e) {
    if (typeof e === 'object') {
      this.setState({ name: e.target.value });
    } else {
      this.setState({ name: e });
    }
  }

  onChangePhone(e) {
    if (typeof e === 'object') {
      this.setState({ phone: e.target.value });
    } else {
      this.setState({ phone: e });
    }
  }

  onChangeReceiverName(e) {
    if (typeof e === 'object') {
      this.setState({ receiverName: e.target.value });
    } else {
      this.setState({ receiverName: e });
    }
  }

  onChangeReceiverPhone(e) {
    if (typeof e === 'object') {
      this.setState({ receiverPhone: e.target.value });
    } else {
      this.setState({ receiverPhone: e });
    }
  }

  onChangePhoneExt(e) {
    if (typeof e === 'object') {
      this.setState({ phoneExt: e.target.value });
    } else {
      this.setState({ phoneExt: e });
    }
  }

  setScrollToComponent() {
    /* eslint-disable global-require */
    this.setState({ scrollToComponent: require('scroll-to-element') });
  }

  scrollToAndReturnIsValid() {
    this.props.setIsValidOrder(false);
    this.state.scrollToComponent(this.Order14ContactInfo, {
      offset: -100,
      duration: 500,
    });
  }

  render() {
    return (
      <Container>
        <p
          ref={i => {
            this.Order14ContactInfo = i;
          }}
        />
        <Row>
          <Col md="5" xs="12">
            <div className={s2.orderSmallTitle}>
              {this.props.modelDataText.contact_info_title}
            </div>
            <Row className={s2.contantInfoTop}>
              <Input
                className={`${s2.iconLeft}`}
                placeholder={
                  this.props.modelDataText.contact_info_nickname_input
                }
                value={this.state.name}
                onChange={e => {
                  this.onChangeName(e);
                }}
              />
              <img
                srcSet={`${imgName} 1x, ${imgName2} 2x`}
                width="24"
                height="24"
                className={`${s2.imgIconLeftTW}`}
                alt="ppl"
              />
            </Row>
            <Row className={s2.contantInfo}>
              <Col md="9" xs="9" style={{ padding: 0 }}>
                <Input
                  className={`${s2.iconLeft}`}
                  style={{
                    borderTopRightRadius: 0,
                    borderBottomRightRadius: 0,
                    paddingRight: '20px',
                  }}
                  placeholder={
                    this.props.modelDataText.contact_info_phone_input
                  }
                  value={this.state.phone}
                  onChange={e => {
                    this.onChangePhone(e);
                  }}
                />
                <img
                  srcSet={`${imgPhone} 1x, ${imgPhone2} 2x`}
                  width="24"
                  height="24"
                  className={`${s2.imgIconLeft}`}
                  alt="phone"
                />
              </Col>
              <Col md="3" xs="3" style={{ padding: 0 }}>
                <Input
                  style={{
                    borderTopLeftRadius: 0,
                    borderBottomLeftRadius: 0,
                    borderLeft: '0px',
                  }}
                  maxLength="5"
                  size="5"
                  placeholder={
                    this.props.modelDataText.contact_info_phone_ext_input
                  }
                  value={this.state.phoneExt}
                  onChange={e => {
                    this.onChangePhoneExt(e);
                  }}
                />
              </Col>
            </Row>
          </Col>
          <Col md={{ size: '5', offset: 1 }} xs="12">
            <div className={s2.orderSmallTitle}>
              {this.props.modelDataText.contact_info_receiver_title}
            </div>
            <Row className={s2.contantInfoTop}>
              <Input
                className={`${s2.iconLeft}`}
                placeholder={
                  this.props.modelDataText.contact_info_nickname_input
                }
                value={this.state.receiverName}
                onChange={e => {
                  this.onChangeReceiverName(e);
                }}
              />
              <img
                srcSet={`${imgName} 1x, ${imgName2} 2x`}
                width="24"
                height="24"
                className={`${s2.imgIconLeftTW}`}
                alt="ppl"
              />
            </Row>
            <Row className={s2.contantInfo}>
              <Input
                className={`${s2.iconLeft}`}
                placeholder={this.props.modelDataText.contact_info_phone_input}
                value={this.state.receiverPhone}
                onChange={e => {
                  this.onChangeReceiverPhone(e);
                }}
              />
              <img
                srcSet={`${imgPhone} 1x, ${imgPhone2} 2x`}
                width="24"
                height="24"
                className={`${s2.imgIconLeftTW}`}
                alt="phone"
              />
            </Row>
          </Col>
        </Row>
        <Row>
          <Col>
            <p
              className={`${s.globalTextRed} ${s.globalFontNormal} ${
                s2.orderWarningText
              }`}
              style={!this.state.isValidName ? {} : { display: 'none' }}
            >
              {this.props.modelDataText.contact_info_nickname_input_warning}
            </p>
          </Col>
          <Col>
            <p
              className={`${s.globalTextRed} ${s.globalFontNormal} ${
                s2.orderWarningText
              }`}
              style={!this.state.isValidReceiverName ? {} : { display: 'none' }}
            >
              {this.props.modelDataText.contact_info_nickname_input_warning}
            </p>
          </Col>
        </Row>
        <Row>
          <Col>
            <p
              className={`${s.globalTextRed} ${s.globalFontNormal} ${
                s2.orderWarningText
              }`}
              style={!this.state.isValidPhone ? {} : { display: 'none' }}
            >
              {this.props.modelDataText.contact_info_phone_input_warning}
            </p>
          </Col>
          <Col>
            <p
              className={`${s.globalTextRed} ${s.globalFontNormal} ${
                s2.orderWarningText
              }`}
              style={
                !this.state.isValidReceiverPhone ? {} : { display: 'none' }
              }
            >
              {this.props.modelDataText.contact_info_phone_input_warning}
            </p>
          </Col>
        </Row>
      </Container>
    );
  }
}
const mapState = state => ({
  user: state.user.user,
  isClickConfirmOrder: state.order.isClickConfirmOrder,
});

const mapDispatch = {
  updateOrderDetailInfoAction,
  setIsValidOrder,
  setIsClickConfirmOrder,
};

export default connect(mapState, mapDispatch)(
  withStyles(bootstrap, s, s2)(Order14ContactInfoWithTW),
);



// WEBPACK FOOTER //
// ./src/routes/order/Order14ContactInfo/Order14ContactInfoWithTW.js